import androidx.compose.runtime.*
import frontend.lib.displayCurrencyPair
import net.sergeych.ugdx.shared.trader.CurrencyPair
import org.jetbrains.compose.web.attributes.name
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.dom.*

class CurrencyPairSelectAttrsBuilder {
    var onChange: (value: CurrencyPair?) -> Unit = {}
    var label: @Composable() () -> Unit = {}
    var options: List<CurrencyPair> by mutableStateOf(emptyList())
    var isDisabled = false
    var isCondensed = false
    var filter: (value: CurrencyPair) -> Boolean = { true }

    fun onChange(handler: (value: CurrencyPair?) -> Unit) { onChange = handler }
    fun label(l: @Composable() () -> Unit) { label = l }
    fun disabled() { isDisabled = true }
    fun options(list: List<CurrencyPair>) {
        options = list
    }

    fun filter(handler: (currency: CurrencyPair) -> Boolean) {
        filter = handler
    }
    fun condensed() { isCondensed = true }
}

@Composable
fun CurrencyPairSelect(
    id: String,
    selected: CurrencyPair?,
    attrs: CurrencyPairSelectAttrsBuilder.() -> Unit = {}
) {
    val builder = CurrencyPairSelectAttrsBuilder()
    attrs.invoke(builder)

    Div() {
        if (!builder.isCondensed) Label(forId = id, attrs = {
            classes("block", "text-sm", "font-medium", "text-gray-700")
        }) { builder.label() }

        Select(attrs = {
            id(id)
            name("select")
            classes("mt-1", "block", "w-full", "pl-3", "pr-10",
                if (builder.isCondensed) "py-1" else "py-2",
                "text-base", "border-gray-300", "focus:outline-none", "focus:ring-indigo-500", "focus:border-indigo-500", "sm:text-sm", "rounded-md")
            onChange {
                val code = it.value
                val currency = builder.options.find {
                    it.base.code + it.quote.code == code
                }
                builder.onChange(currency)
            }
        }) {
            builder.options.forEach {
                val option = it
                val id = option.base.code + option.quote.code

                Option(id, attrs = {
                    if (selected?.base?.code + selected?.quote?.code == id) selected()
                }) { Text(displayCurrencyPair(option)) }
            }
        }
    }
}
